import { Categories } from 'src/app/views/common/models/categories_model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RouteInfo } from 'src/app/shared/sidebar/sidebar.metadata';
import { StoreCategories } from '../models/store_categories_model';

@Injectable({
  providedIn: 'root'
})
export class OpAdminCategoriesService {

  constructor(private http: HttpClient) { }
  setHeader() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return headers;
  }

  private sidebarnavItems: RouteInfo[] = [];
  myHeaders = this.setHeader();

  panoramaCategories(storeType) {
    let url = environment.URL + "/panorama/category/getall/" + storeType;
    return this.http.get(url, { headers: this.myHeaders });
  }

  getAllCategories(storeType) {
    let url = environment.URL + "/category/getall/" + storeType;
    return this.http.get(url, { headers: this.myHeaders });
  }

  getAllStoreCategories() {
    let url = environment.URL + "/store-category/getall/";
    return this.http.get(url, { headers: this.myHeaders });
  }

  categoryRecordById(categoryId) {
    let url = environment.URL + "/category/edit/" + categoryId;
    return this.http.get(url, { headers: this.myHeaders });
  }
  storeCategoryRecordById(categoryId) {
    let url = environment.URL + "/store-category/edit/" + categoryId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  saveCategories(bodyParams: Categories) {
    let url = environment.URL + "/category/create";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  saveStoreCategories(bodyParams: StoreCategories) {
    let url = environment.URL + "/store-category/create";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  updateCategories(bodyParams: Categories) {
    let url = environment.URL + "/category/update";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  updateStoreCategories(bodyParams: StoreCategories) {
    let url = environment.URL + "/store-category/update";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  deleteCategories(bodyParams: Categories) {
    let url = environment.URL + "/category/delete/" + bodyParams.id;
    return this.http.get(url, { headers: this.myHeaders });
  }

  deleteStoreCategories(bodyParams: StoreCategories) {
    let url = environment.URL + "/store-category/delete/" + bodyParams.id;
    return this.http.get(url, { headers: this.myHeaders });
  }

  tableSearch(value, column, pageId) {
    let url = environment.URL + "/category/" + value + "/" + column + "?page=" + pageId;
    return this.http.get(url, { headers: this.myHeaders });
  }
  storeTableSearch(value, column, pageId) {
    let url = environment.URL + "/store-category/" + value + "/" + column + "?page=" + pageId;
    return this.http.get(url, { headers: this.myHeaders });
  }
  getCodeList(moduleName) {
    let url = environment.URL + "/code/" + moduleName;
    return this.http.get(url, { headers: this.myHeaders });
  }

}

